var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 13V17.375C9.96094 19.7875 11.9234 21.75 14.3359 21.75C16.7484 21.75 18.7109 19.7875 18.7109 17.375V10.5C18.7109 5.6625 14.7984 1.75 9.96094 1.75C5.12344 1.75 1.21094 5.6625 1.21094 10.5V18C1.21094 22.1375 4.57344 25.5 8.71094 25.5",
    stroke: "#8D8F98",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/AttachmentIcon.86b38ac623c7b01e92eb5767a8183755.svg";
export { ForwardRef as ReactComponent };